<div class="loader-wrapper" [class.loderhide]="!show">
  <div class="typewriter">
    <h1 class="head">ELT&#64;I Loading...</h1>
  </div>
</div>